import React from 'react';
import {  ListGroupItem, Row ,Col} from 'reactstrap';
import moment from "moment";

export const CalendarReminderNotify = ({ data, type, index, onClientRedirect, removeNotificationAndClose }) => {

    const onNotificationClick = (e, data) => {
        e.preventDefault();
        if (data.contractId !== '00000000-0000-0000-0000-000000000000') {
            onClientRedirect(data.contractId, index, data, type);
        }
    }

    const onCloseHanlder = (e) => {
        e.preventDefault();
        removeNotificationAndClose(index,true);
    }

    return <ListGroupItem key={index}
    className="list-group-item-action">
    <Row className="align-items-center">
        <Col md="11" className="pr-1">
            <a href="#item"  className="list-group-item-action" onClick={e => onNotificationClick(e, data)}>
            {data.contractId === '00000000-0000-0000-0000-000000000000' &&
                <p className="text-sm mb-0">Your next meeting <span className="h5">{data.title}</span> is coming up at <span className="h5 ">{moment(data.eventDate).format('HH:mm a')}</span>.</p>
            }

            {data.contractId !== '00000000-0000-0000-0000-000000000000' &&
                <p className="text-sm mb-0"> Your next meeting <span className="h5">{data.title}</span> is coming up at <span className="h5 ">{moment(data.eventDate).format('HH:mm a')}</span>. Click to go to the client details.</p>
           
           }
            </a>
           
        </Col>
        <Col md="1" className="pl-0">
            <a href="#delelte" onClick={ e=> onCloseHanlder(e)}>
            <i className="ni ni-fat-remove"></i>
            </a>
        </Col>
    </Row>
</ListGroupItem>;    
};